import ActionTypes, {MattersActionTypes} from "../constants/action_types";

export type MattersClearAction = {
  type: MattersActionTypes["MATTER_CLEAR"]["SUCCESS"];
  payload: undefined;
};

export default function clearMatter() {
  return {
    type: ActionTypes.MATTER_CLEAR.SUCCESS,
  };
}
